export const MAX_ARTIFACT_FILE_SIZE = 4 * 1024 * 1024;

export const MAX_ARTIFACT_TOTAL_SIZE = 4 * 1024 * 1024;

export const MAX_ARTIFACT_FILE_SIZE_MESSAGE =
  'Artifact must be smaller than 4 MB. Please choose a smaller file.';

export const MAX_ARTIFACT_TOTAL_SIZE_MESSAGE =
  'Selected artifacts total more than 4 MB. Remove one or more files before submitting.';

export const getOversizedFilesMessage = (names) => {
  const isPlural = names.length > 1;

  return `${names.join(', ')} ${isPlural ? 'are' : 'is'} larger than 4 MB and cannot be uploaded. ` +
    `Remove ${isPlural ? 'them' : 'it'} before submitting.`;
};
